import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { TransactionDetailPanelComponent } from './lib/transaction-detail-panel.component'
import { TransactionDetailKey } from './panel-key'

export * from './lib/transaction-detail.module'
export * from './panel-key'

export const TransactionDetailPanelConfig: PanelConfig = {
  key: TransactionDetailKey,
  title: 'Transaction Detail',
  description:
    'View details for a selected transaction, including source data and Clearwater identifiers.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: TransactionDetailPanelComponent,
  accessPermission: 'accessTransactionDetailPanel',
}
